import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import OrientationGuard from './features/orientation/OrientationGuard';
import InstallAppBanner from './features/install-banner/InstallAppBanner';
import AppLaunchScreen from './features/launch-screen/AppLaunchScreen';
import { registerAppServiceWorker } from './utils/appServiceWorker';
import {
  armOneTimePushPermissionRequest,
  syncExistingPushRegistration,
} from './utils/pushMessaging';

const disablePageZoom = () => {
  let lastTouchEndAt = 0;
  const isCoarsePointer = () =>
    window.matchMedia?.('(pointer: coarse)').matches ||
    window.matchMedia?.('(max-width: 767px)').matches;

  const preventZoom = (event) => {
    if (!isCoarsePointer()) return;
    event.preventDefault();
  };

  const preventMultiTouchZoom = (event) => {
    if (!isCoarsePointer()) return;
    if (event.touches.length > 1) {
      event.preventDefault();
    }
  };

  const preventDoubleTapZoom = (event) => {
    if (!isCoarsePointer()) return;

    const now = Date.now();
    if (now - lastTouchEndAt <= 350) {
      event.preventDefault();
    }
    lastTouchEndAt = now;
  };

  document.addEventListener('gesturestart', preventZoom, { passive: false });
  document.addEventListener('gesturechange', preventZoom, { passive: false });
  document.addEventListener('gestureend', preventZoom, { passive: false });
  document.addEventListener('touchmove', preventMultiTouchZoom, { passive: false });
  document.addEventListener('touchend', preventDoubleTapZoom, { passive: false });
  document.addEventListener(
    'wheel',
    (event) => {
      if (event.ctrlKey) {
        event.preventDefault();
      }
    },
    { passive: false }
  );
};

const renderApplication = () => {
  const root = ReactDOM.createRoot(document.getElementById('root'));

  root.render(
    <>
      <AppLaunchScreen />

      <React.StrictMode>
        <InstallAppBanner>
          <OrientationGuard>
            <App />
          </OrientationGuard>
        </InstallAppBanner>
      </React.StrictMode>
    </>
  );
};

const bootstrapApplication = () => {
  disablePageZoom();

  /*
   * Development must not register, replace, claim, or otherwise manage a
   * Service Worker. react-scripts already serves its standard no-op worker
   * for localhost specifically to retire a stale production worker safely.
   * Running a second custom development worker on the same scope can race
   * with that cleanup and cause repeated navigations / full-page reloads.
   */
  if (process.env.NODE_ENV === 'production') {
    registerAppServiceWorker();
    syncExistingPushRegistration().catch((error) => {
      console.error('CheKhabare push sync failed:', error);
    });
    armOneTimePushPermissionRequest().catch((error) => {
      console.error('CheKhabare push permission lifecycle failed:', error);
    });
  }

  renderApplication();
};

bootstrapApplication();

